export default class AppConfig {
    static simpleDrawerWidth = 'small';
    static mapCenter = [-72.6658, 44.0687];
    static mapBounds = [[-80, 40.291422],[-64, 46.427047]];
    static mapVermontBounds = {lng: [-73.343443, 42.726995], lat: [-71.465131, 45.15]};
    static passwordValidationRegex = /(?=.{8,})(?=.*?[^\w\s])(?=.*?[0-9])(?=.*?[A-Z]).*?[a-z].*/;
    static passwordValidationInstructions = 
    'Minimum 8 characters, must include at least one upper case letter, one lower case letter, one number, and one special character.'
}